import { FetchAPI } from './auth-service';

const fields = [
  {
    variable: "name",
    title: "Policy Name",
    hidden: false,
    type: "string",
    field: "name",
  },
  {
    variable: "enable",
    title: "Enforcement",
    hidden: false,
    type: "string",
    field: "enable",
  },
  {
    variable: "region",
    title: "Region",
    hidden: false,
    type: "string",
    field: "region",
  },
  {
    variable: "priority",
    title: "Priority",
    hidden: false,
    type: "number",
    field: "priority",
  },
  {
    variable: "network",
    title: "Mirrored/collector vpc",
    hidden: false,
    type: "string",
    field: "network",
  },
  {
    variable: "instances",
    title: "Mirrored Instance",
    hidden: false,
    type: "string",
    field: "instances",
  },
  {
    variable: "collectorIlb",
    title: "Collector ILB",
    hidden: false,
    type: "string",
    field: "collectorIlb",
  },
  {
    variable: "filter",
    title: "Mirror Traffic",
    hidden: false,
    type: "string",
    field: "filter",
  },
];

class PacketMirrorServiceData {
  constructor() {
    // we only need one of these
    if (!PacketMirrorServiceData.instance) {
      PacketMirrorServiceData.instance = this;
    }
    this.searchPlaceholder = 'Search Packet Mirror';
    this.fields = fields;


    this.AggregatedListpacketMirrors = () => {
      return FetchAPI({
        url: `system/gcp/aggregated/mirroring`,
        method: 'GET',
      });
    };


    this.DeletepacketMirror = (region, packetmirror) => {
      return FetchAPI({
        url: `system/gcp/mirroring/${region}/${packetmirror}`,
        method: 'DELETE',
      })
    },

      this.getPacketMirror = (region, name) => {
        return FetchAPI({
          url: `system/gcp/mirroring/${region}/${name}`,
          method: 'GET',
        })
      },

      this.updatePacketMirror = (region, name, body) => {
        return FetchAPI({
          url: `system/gcp/mirroring/${region}/${name}`,
          method: 'PUT',
          body: body
        })
      }

    this.createpacketMirroring = (region, body) => {
      return FetchAPI({
        url: `system/gcp/mirroring/${region}`,
        method: 'POST',
        body: body

      })
    }

    return PacketMirrorServiceData.instance;
  }
}

const PacketMirrorService = new PacketMirrorServiceData();

export {
  PacketMirrorService as default,
  fields as PacketMirrorFields,
};
